var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 32,
    viewBox: "0 0 2 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 6,
    r: 1,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 11,
    r: 1,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 16,
    r: 1,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 21,
    r: 1,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 26,
    r: 1,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 31,
    r: 1,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame36);
export default __webpack_public_path__ + "static/media/Frame 36.f2c5fb02d2658a4dfe91584a4b5f8ba7.svg";
export { ForwardRef as ReactComponent };